<template>
	<div id="app">
		<PoiSlideshow 
			:isReal="isReal"
			:language="currentLanguage"
			:real-position="realPosition"
			:pois="pois"
			:points-of-interests="pois"
			@updatesim="updateSimulated($event)"
		></PoiSlideshow>
		<LanguageSelector @changelang="changeLanguage($event)"></LanguageSelector>
		<LeafletMap 
			:simulatedPosition="simulatedPosition"
			:isReal="isReal"
			@realupdate="realupdate"
			@pois-ready="onPoisReady"
		></LeafletMap>
	</div>
</template>

<script>
/* eslint-disable */
import LeafletMap from './components/leaflet-map.vue'
import PoiSlideshow from './components/poi-slideshow.vue'
import LanguageSelector from './components/language-selector.vue'

export default {
	name: 'app',
	components: {
		LeafletMap,
		PoiSlideshow,
		LanguageSelector
	},
	data() {
		return {
			serviceWorkerFilePath: '/service-worker.js',
			currentLanguage: 'en',
			isReal: 1,
			simulatedPosition: {lat: 0, lon: 0},
			realPosition: undefined,
			pois: []
		};	
	},
	
	mounted() {
		//register service worker
		if('serviceWorker' in navigator) {
			console.info('CLIENT: service worker registration in progress');
			navigator.serviceWorker.register(this.serviceWorkerFilePath).then(function(){
				console.info('CLIENT: service worker registration complete');
			}, function(){
				console.error('CLIENT: service worker registration failure');
			});
		}
		else {
			alert('service worker nope');
			console.error('CLIENT: service worker is not supported');
		}
	},

	methods: {
		changeLanguage(lang){
			this.currentLanguage = lang;
		},
		updateSimulated(position){
			this.simulatedPosition = position;
		},
		realupdate(e) {

			this.realPosition = {
				lat: e.coords.latitude,
				lon: e.coords.longitude
			};

		},
		onPoisReady(pois) {

			this.pois = pois;

		}
	}
}
</script>

<style>

html
{
	background-color: black;
	color: white;
}

#app {
	display: grid;
	grid-template-rows: 54vh 6vh 40vh;
	font-family: 'raleway';
}

@font-face
{
	font-family: 'raleway';
	src: url('./assets/fonts/Raleway/Raleway-Regular.ttf');
}
</style>
